export default {
  how_to_place_order: {
    header: 'Wie gebe ich eine Bestellung auf?',
    body: 'Stöbere einfach im Menü, füge Artikel zu deinem Warenkorb hinzu und folge den Schritten zum Bezahlen. Du erhältst eine Bestätigung, sobald die Bestellung aufgegeben wurde.',
  },
  schedule_order: {
    header: 'Kann ich eine Bestellung im Voraus planen?',
    body: 'Ja! Wähle beim Bezahlen die Option „Planen“, um eine zukünftige Abholzeit zu wählen, die dir am besten passt.',
  },
  customize_order: {
    header: 'Kann ich meine Bestellung anpassen?',
    body: 'Absolut. Tippe auf ein Menüelement, um Anpassungsoptionen wie Toppings, Beilagen und Präferenzen zu sehen.',
  },
  track_order: {
    header: 'Wie verfolge ich meine Bestellung?',
    body: 'Nach dem Aufgeben deiner Bestellung siehst du Echtzeit-Updates in der App – von der Bestätigung über die Zubereitung bis zur Abholbereitschaft.',
  },
  cancel_or_edit_order: {
    header: 'Kann ich meine Bestellung nach dem Aufgeben stornieren oder ändern?',
    body: 'Falls deine Bestellung noch nicht in der Zubereitung ist, kannst du Änderungen anfordern, indem du das Restaurant direkt über die App kontaktierst.',
  },
  payment_methods: {
    header: 'Welche Zahlungsmethoden werden akzeptiert?',
    body: 'Wir akzeptieren gängige Kredit-/Debitkarten, Apple Pay und Google Pay, je nach deinem Gerät.',
  },
  no_confirmation: {
    header: 'Ich habe keine Bestätigung erhalten. Was soll ich tun?',
    body: 'Überprüfe den Spam-Ordner deiner E-Mails oder gehe zum Reiter „Bestellungen“ in der App. Falls du sie immer noch nicht findest, kontaktiere das Restaurant direkt.',
  },
  pickup_instructions: {
    header: 'Wo hole ich meine Bestellung ab?',
    body: 'Abholanweisungen werden auf dem Bestätigungsbildschirm und in deiner Bestellübersicht angezeigt. Achte auf Beschilderungen oder frage das Personal bei deiner Ankunft.',
  },
  loyalty_points: {
    header: 'Kann ich mit meinen Bestellungen Treuepunkte sammeln?',
    body: 'Ja, berechtigende Käufe sammeln automatisch Punkte. Du kannst dein Guthaben und deine Prämien auf dem Hauptbildschirm der App einsehen.',
  },
  apply_promo_code: {
    header: 'Wie wende ich einen Aktionscode oder Rabatt an?',
    body: 'Während des Bezahlvorgangs siehst du eine Option, um einen Aktionscode einzugeben. Verfügbare Rabatte werden auch automatisch angewendet, falls du berechtigt bist.',
  },
  issue_with_order: {
    header: 'Was soll ich tun, wenn es ein Problem mit meiner Bestellung gibt?',
    body: 'Wir sind hier, um zu helfen. Kontaktiere das Restaurant über die App oder sende eine E-Mail direkt an den Support über die Option „Support kontaktieren“.',
  },
  use_loyalty_and_coupon: {
    header:
      'Kann ich Treuepunkte und einen Gutschein (wie „Kauf 1, erhalte 1 gratis“) für dieselbe Bestellung verwenden?',
    body: 'Nein – pro Bestellung kann nur ein Rabatt oder Angebot angewendet werden. Dies gewährleistet eine faire Nutzung von Prämien und Aktionen. Wähle die Option, die dir den besten Wert bietet!',
  },
};
